// Cuándo vuelve a intentar el guardado de un proyecto del Estudio que falló —
// ADR-2026-11-02-el-estudio-guarda-solo-lo-ultimo-y-avisa-si-falla.
//
// Vive aparte del hook para poder testearlo sin DOM. Las esperas crecen para no
// martillar la base durante un corte, y se quedan en la última: el editor sigue
// abierto y la persona sigue trabajando, así que el guardado no se rinde nunca
// (lo que sí hace es avisar, con `AvisoDeGuardado`).

/** Esperas entre reintentos, en ms: la primera rápida (un corte de un segundo), después más largas. */
export const ESPERAS_DE_REINTENTO_MS = [3_000, 10_000, 30_000] as const;

/**
 * Cuánto esperar antes del próximo intento, según cuántos fallaron seguidos.
 * `intentosFallidos` arranca en 1 (el primero que falló).
 */
export function esperaAntesDeReintentar(intentosFallidos: number): number {
  const i = Math.max(1, Math.floor(intentosFallidos)) - 1;
  return ESPERAS_DE_REINTENTO_MS[Math.min(i, ESPERAS_DE_REINTENTO_MS.length - 1)];
}

/** Espera del guardado automático después del último cambio (la de siempre). */
export const ESPERA_DEL_GUARDADO_MS = 3_000;
